import { tempoApi } from '@/lib/api/tempoApi';
import type { TimeLineDataSet, TimelineItem } from '../types/adaptive-planner/scenario-item';

const getTimelineDataSet = async ({
  planId,
  scenarioId,
}: {
  planId: number;
  scenarioId: number;
}) => {
  const response = await tempoApi()
    .get(`api/v1/adaptive-planner/plans/${planId}/scenarios/${scenarioId}/timeline-items/data-set`)
    .json<TimeLineDataSet[]>();

  return response;
};

const getTimelineItemsBulkFetch = async ({
  ids,
  planId,
  scenarioId,
}: {
  ids: number[];
  planId: number;
  scenarioId: number;
}): Promise<TimelineItem[]> => {
  const response = await tempoApi()
    .post(
      `api/v1/adaptive-planner/plans/${planId}/scenarios/${scenarioId}/timeline-items/bulk-fetch`,
      {
        json: ids,
      },
    )
    .json<TimelineItem[]>();

  return response;
};

export const AdaptivePlannerTimelineApi = {
  getTimelineDataSet,
  getTimelineItemsBulkFetch,
} as const;
